import { unleashEnabled } from '@/app.config'

export const filterAvailableLanguages = (languages, tenant = global.realm_tenant) => {
  if (unleashEnabled === '1' && global.unleash) {
    return languages.filter(locale => global.unleash.isEnabled(`language.${locale.locale.substring(0, 2)}`))
  }
  return languages
}

export const cookieEnabled = (tenant = global.realm_tenant) => {
  if (unleashEnabled === '1' && global.unleash) {
    return global.unleash.isEnabled(`chatplugin.cookie`)
  }
  return false
}
